module.exports = __webpack_public_path__ + "img/sharedMediaFolders.896fd2c0.svg";